/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Nav_P_Approval_DInputs */

const en_mk_nav_p_approval_d = /** @type {(inputs: Mk_Nav_P_Approval_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agents ask permission before anything leaves the building.`)
};

const id_mk_nav_p_approval_d = /** @type {(inputs: Mk_Nav_P_Approval_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agen minta izin sebelum bertindak keluar.`)
};

/**
* | output |
* | --- |
* | "Agents ask permission before anything leaves the building." |
*
* @param {Mk_Nav_P_Approval_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_nav_p_approval_d = /** @type {((inputs?: Mk_Nav_P_Approval_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Nav_P_Approval_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_nav_p_approval_d(inputs)
	return en_mk_nav_p_approval_d(inputs)
});